"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _components = require("../../components");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  /** Image url */
  image: _propTypes.string,

  /** Title text usually a text, but can be a React component  */
  title: _propTypes.node,

  /** titleFont with fontPropType */
  titleFont: _utils.fontPropType
};
var DiagramImage = (0, _styledComponents["default"])(_primitives["default"].Image).withConfig({
  displayName: "diagram-panel__DiagramImage",
  componentId: "sc-cyw5fz-0"
})(["flex-shrink:0;max-height:100%;max-width:100%;"]);

var DiagramPanel = function DiagramPanel(_ref) {
  var image = _ref.image,
      title = _ref.title,
      titleFont = _ref.titleFont;
  return /*#__PURE__*/_react["default"].createElement(_components.PanelContent, {
    alignItems: "center",
    justifyContent: "center",
    title: title,
    titleFont: titleFont
  }, /*#__PURE__*/_react["default"].createElement(DiagramImage, {
    height: "auto",
    src: image,
    width: "auto"
  }));
};

DiagramPanel.propTypes = propTypes;
DiagramPanel.displayName = "Modules.DiagramPanel";

var _default = (0, _styledComponents.withTheme)(DiagramPanel);

exports["default"] = _default;